import { createSlice } from '@reduxjs/toolkit';
import { defaultCreateAccountEmailVerificationSlice } from '@/redux/modules/account/createAccountEmailVerification/createAccountEmailVerification.types';
import {
    sendEmailVerificationCode,
    submitEmailVerificationCode,
} from '@/redux/modules/account/createAccountEmailVerification/createAccountEmailVerification.actions';
import { submitCreateAccount } from '../createAccount/createAccount.actions';

const createAccountEmailVerificationSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(sendEmailVerificationCode.pending, (slice) => {
            slice.sendOtp.error = null;
            slice.sendOtp.submitted = true;
            slice.sendOtp.success = false;
            slice.verifyOtp.error = null;
            slice.verifyOtp.submitted = false;
            slice.verifyOtp.success = false;
        });
        builder.addCase(sendEmailVerificationCode.fulfilled, (slice, { payload }) => {
            slice.unregisteredUserId = payload;
            slice.sendOtp.error = null;
            slice.sendOtp.submitted = false;
            slice.sendOtp.success = true;
        });
        builder.addCase(sendEmailVerificationCode.rejected, (slice, { payload }) => {
            slice.sendOtp.error = payload;
            slice.sendOtp.submitted = false;
            slice.sendOtp.success = false;
        });
        builder.addCase(submitEmailVerificationCode.pending, (slice) => {
            slice.verifyOtp.error = null;
            slice.verifyOtp.submitted = true;
            slice.verifyOtp.success = false;
        });
        builder.addCase(submitEmailVerificationCode.fulfilled, (slice) => {
            slice.verifyOtp.error = null;
            slice.verifyOtp.submitted = false;
            slice.verifyOtp.success = true;
        });
        builder.addCase(submitEmailVerificationCode.rejected, (slice, { payload }) => {
            slice.verifyOtp.error = payload;
            slice.verifyOtp.submitted = false;
            slice.verifyOtp.success = false;
        });

        // Reset the slice when the create account is successful
        builder.addCase(submitCreateAccount.fulfilled, () => defaultCreateAccountEmailVerificationSlice);
    },
    initialState: defaultCreateAccountEmailVerificationSlice,
    name: 'createAccountEmailVerification',
    reducers: {},
});

export const { reducer: createAccountEmailVerificationReducer } = createAccountEmailVerificationSlice;
